module.exports = __webpack_public_path__ + "fonts/CalibreBlack.1ea38e9a.woff";